import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_CAUSE = {
	name: "OBSERVATION_CAUSE",
	concept: {
		ALCOHOL: {
			display: {
				"nl-BE": "Alcohol",
				"fr-BE": "Alcool",
			},
		},
		ASSISTIVE_DEVICE: {
			display: {
				"nl-BE": "(Probleem met) Hulpmiddel",
				"fr-BE": "(Problème avec) Dispositif d'assistance",
			},
		},
		BALANCE_DISORDER: {
			display: {
				"nl-BE": "Evenwichtstoornis",
				"fr-BE": "Trouble de l'équilibre",
			},
		},
		LEGACY_BENDING_OVER: {
			display: {
				"nl-BE": "Vooroverbuigen",
				"fr-BE": "En ce penchant",
			},
		},
		CALL_BELL_OUT_OF_REACH: {
			display: {
				"nl-BE": "Bel buiten bereik",
				"fr-BE": "Sonnette hors de portée",
			},
		},
		LEGACY_CHAIR_SLID_OFF: {
			display: {
				"nl-BE": "Stoel/rolstoel/bed weggeschoven",
				"fr-BE": "Chaise/fauteuil/lit a glissé",
			},
		},
		LEGACY_COMING_OUT_OF_BED: {
			display: {
				"nl-BE": "Uit bed komen",
				"fr-BE": "Sortir du lit",
			},
		},
		COGNITIVE_DECLINE: {
			display: {
				"nl-BE": "Cognitieve achteruitgang",
				"fr-BE": "Déclin cognitif",
			},
		},
		DIFFICULTY_WALKING: {
			display: {
				"nl-BE": "Moeilijk stappen",
				"fr-BE": "Difficulté à marcher",
			},
		},
		DISEASE_INSIGHT: {
			display: {
				"nl-BE": "Ziekteinzicht",
				"fr-BE": "Compréhension de la maladie",
			},
		},
		LEGACY_DROPPED_BY_KNEE: {
			display: {
				"nl-BE": "Door de knie gezakt",
				"fr-BE": "Tombé par le genou",
			},
		},
		INADEQUATE_FOOTWEAR: {
			display: {
				"nl-BE": "Slecht schoeisel",
				"fr-BE": "Chaussures inadéquates",
			},
		},
		LOW_BLOOD_PRESSURE: {
			display: {
				"nl-BE": "Lage bloeddruk",
				"fr-BE": "Basse pression sanguine",
			},
		},
		MEDICATION: {
			display: {
				"nl-BE": "Medicatie",
				"fr-BE": "Médicament",
			},
		},
		OBSTACLE: {
			display: {
				"nl-BE": "Hindernis",
				"fr-BE": "Obstacle",
			},
		},
		PATHOLOGY: {
			display: {
				"nl-BE": "Ziektebeeld",
				"fr-BE": "Tableau clinique",
			},
		},
		LEGACY_REMOVING_FIXATION: {
			display: {
				"nl-BE": "Fixatie verwijderen",
				"fr-BE": "Retrait de la fixation",
			},
		},
		RESTRAINT_MEASURE: {
			display: {
				"nl-BE": "Vrijheidsbeperkende maatregel",
				"fr-BE": "Mesure restrictive de liberté",
			},
		},
		LEGACY_SAT_POORLY_ON_CHAIR: {
			display: {
				"nl-BE": "Slecht op en naast stoel zitten",
				"fr-BE": "S'est mal assis sur et à côté d'une chaise",
			},
		},
		SLIPPERY_FLOOR: {
			display: {
				"nl-BE": "Gladde vloer",
				"fr-BE": "Sol glissant",
			},
		},
		LEGACY_STUMBLE: {
			display: {
				"nl-BE": "Struikelen/uitschuiven",
				"fr-BE": "En trébuchant",
			},
		},
		LEGACY_TRYING_TO_GET_IN_OR_OUT_BED_ALONE: {
			display: {
				"nl-BE": "Alleen in/uit bed willen gaan",
				"fr-BE": "Essayer de se lever ou de se coucher seul",
			},
		},
		LEGACY_TUNED_FOOT: {
			display: {
				"nl-BE": "Voet omgeslagen",
				"fr-BE": "Pied tourné",
			},
		},
		LEGACY_UNEVEN_TERRAIN: {
			display: {
				"nl-BE": "Oneffenheden/trapje/mat",
				"fr-BE": "Terrain accidenté",
			},
		},
		VISION: {
			display: {
				"nl-BE": "Zichtproblemen",
				"fr-BE": "Problèmes de vision",
			},
		},
		LEGACY_OTHER: {
			display: {
				"nl-BE": "Andere",
				"fr-BE": "Autre",
			},
		},
	},
} as const satisfies CodeSystem;
